var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9992 5.83301C22.1202 5.83301 16.482 8.16842 12.325 12.3255C8.16793 16.4825 5.83252 22.1207 5.83252 27.9997C5.83252 33.8786 8.16793 39.5168 12.325 43.6739C16.482 47.8309 22.1202 50.1663 27.9992 50.1663C33.8781 50.1663 39.5163 47.8309 43.6734 43.6739C47.8304 39.5168 50.1658 33.8786 50.1658 27.9997C50.1658 22.1207 47.8304 16.4825 43.6734 12.3255C39.5163 8.16842 33.8781 5.83301 27.9992 5.83301Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.0015 33.8754H36.738L37.6387 28.0479H31.0003V24.8629C31.0003 22.4421 31.7913 20.2954 34.0558 20.2954H37.6947V15.2099C37.0553 15.1236 35.7032 14.9346 33.1482 14.9346C27.813 14.9346 24.6852 17.7521 24.6852 24.1711V28.0479H19.2007V33.8754H24.6852V49.8926C25.7714 50.0559 26.8715 50.1667 28.0008 50.1667C29.0217 50.1667 30.018 50.0734 31.0015 49.9404V33.8754Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5cc1928435d26b59683fbbc0cdb05f1a.svg";
export { ForwardRef as ReactComponent };